import type * as stream from 'getstream';
import type { EnrichOptions, UR } from 'getstream';

export enum FeedType {
  UserUpdates = 'userUpdates',
  Posts = 'posts',
}
// Notes on activities:
// actor: string; // GIK user id
// id: string; // stream-generated activity id
// object: string; // our ID to reference the activity (GUID for user updates and events)

export type StreamGetFeedOptions = stream.GetFeedOptions & { allPages?: boolean };
export type StreamFeed = stream.StreamFeed;
export type FlatActivity = stream.FlatActivityEnriched;
export type Reaction<T extends UR> = stream.EnrichedReaction<T>;
export type EnrichedReactionAPIResponse = stream.EnrichedReactionAPIResponse;
export interface UserUpdateActivity extends FlatActivity {
  userUpdate: {
    title: string;
    description: string;
    publishedDate: string;
  };
  userUpdateStatic: {
    organiserId: string;
    organiserFullName: string;
    pageRouteId: string;
  };
  userUpdateMedia?: { [key: string]: PostMedia };
  media?: { [key: string]: PostMedia };

  // legacy property used before the comments feature. old deleted updates still use this while newer use deletedTime
  userUpdateDeleted?: boolean;
  deleted?: boolean;
}
export interface PostActivity extends FlatActivity {
  post: {
    userId: string;
    pageRouteId: string;
    message: string;
    backgroundColor: string;
  };
  media?: {
    [x: string]: PostMedia;
  };
  deleted?: boolean;
}

export type PostOptions = {
  backgroundColor: string;
};

export type StreamComment = {
  message: string;
  userId: string;
  updatedTime?: string;
  deletedBy?: string;
  deletedTime?: string;
};

export type GetFeedOptions = {
  allPages?: boolean; // handled in .NET
  perPage?: number;
  page?: number;
  offset?: number;
  idGreaterThan?: string;
  idLessThan?: string;
  idLessOrEqualThan?: string;
  idGreaterOrEqualThan?: string;
  recentReactionsLimit?: number;
} & EnrichOptions;

export type PostMedia = {
  caption?: string;
  id: string;
  thumbnailUrl: string;
  type: 'photo';
  url: string;
};
